const footerLinks = [
  { id: "overview", label: "版本一览" },
  { id: "glossary", label: "术语词典" },
  { id: "compare", label: "版本对比" },
  { id: "filter", label: "速查筛选" },
  { id: "checklist", label: "观看前检查" },
  { id: "faq", label: "常见问题" },
];

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200 bg-secondary-100">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-film-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-base font-bold text-foreground-950">嫂子的诱惑 · 字幕索引</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              本页围绕《嫂子的诱惑》的中文字幕、国语版、中文配音、字幕在线、中字与普通话等信息，
              提供一般性的术语解释与版本判断思路，帮助你更快定位所需内容。
            </p>
          </div>

          <nav aria-label="页脚分区导航">
            <h2 className="font-heading text-sm font-bold text-foreground-950">页面分区</h2>
            <ul className="mt-4 space-y-2">
              {footerLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h2 className="font-heading text-sm font-bold text-foreground-950">内容说明</h2>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5 text-secondary-700" aria-hidden="true"></i>
                本页为信息索引，不提供播放或下载。
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-refresh-line mt-0.5 text-secondary-700" aria-hidden="true"></i>
                术语与形式说明可能随版本不同而有差异。
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-user-line mt-0.5 text-secondary-700" aria-hidden="true"></i>
                请以实际版本的标注信息为准。
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>嫂子的诱惑 · 中文字幕与国语版信息索引</p>
          <p>内容为一般性说明，仅供参考。</p>
        </div>
      </div>
    </footer>
  );
}